import { ApplicationState } from 'ducks/application-state';

export const selectNotification = (state: ApplicationState) => state.notification.list;
export const selectNotificationPagination = (state: ApplicationState) => state.notification.pagination;
export const selectNotificationSort = (state: ApplicationState) => state.notification.sort;
export const selectNotificationLoading = (state: ApplicationState) => state.notification.loading;
export const selectNotificationNewSize = (state: ApplicationState) => state.notification.newSize;
